import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { LatLngModel } from "../../models/geolocation/lat-lng.model";

import { ApiRequestDispatcherService } from "../api/api-request-dispatcher.service";
import { ApiResponseDispatcherService } from "../api/api-response-dispatcher.service";

@Injectable({
    providedIn: "root"
})
export class MapQuestGeolocationService {
    private readonly API_GET_COORDINATES_URL = "/api/geolocation/map-quest/get-coordinates-by-address";

    public constructor(
        private _requestDispatcher: ApiRequestDispatcherService,
        private _responseDispatcher: ApiResponseDispatcherService
    ) {
    }

    public getCoordinatesByAddress(location: string): Observable<LatLngModel> {
        const response$ = this._requestDispatcher.get<LatLngModel>(this.API_GET_COORDINATES_URL, { location: location });
        return this._responseDispatcher.unwrap(response$);
    }
}
